import {CollectionFollower} from 'data/records'
import {resource, collection as c, findSelector} from 'data/helpers/apiv3'

const [api, actions] = resource(CollectionFollower, [
  ['create', c.post('', ['collectionId', 'privacyCode'])],
  ['list', c.get('', ['collectionId', 'userId'])]
])

const selectors = {
  ...findSelector(CollectionFollower),
  byCollectionAndUser: (state, collectionId, userId) => state.apiv3.collectionFollower.id.find(
    follow => follow.userId === userId && follow.collectionId === collectionId
  )
}

const reducers = {}

const initialState = {}

export {
  api as collectionFollowerApi,
  actions as collectionFollowerActions,
  selectors as collectionFollowerSelectors,
  reducers as collectionFollowerReducers,
  initialState as collectionFollowerInitialState
}
